<template>
    <router-view></router-view>
     <footer-two></footer-two>
</template>